<template  >


    <v-container style="margin-top:60px;" class="">
        <v-card class="mx-auto" dark style="background:transparent;" flat>
            <div style="text-align: center;">Alerts</div>
            <v-card-text style="text-align: center;">
                Använd Hihats egna alertsystem som en browsersource, eller anslut ditt Hihat-konto till en tredjepart.

            </v-card-text>
        </v-card>
                    <v-row justify="center" style="min-height:100%;" align="center">
                        <v-col class="col-12 col-lg-4 my-8">

                            <v-card
                                    dark
                                    width="400px"
                                    height="400px"
                                    class="mx-auto"

                            >
                              <v-avatar  style="position: absolute;top:10px;right:10px;" class="mr-0" height="40" width="40">
                                    <img
                                            :src="require('../assets/hi_icon.png')"
                                    >
                                </v-avatar>


                                <v-card-text>
                                    <div style="width:100%;">

                                        Hihat

                                    </div>


                                </v-card-text>
                                <v-card-actions style="margin-top:100px;">
                                    <v-btn  @click="new_hihat"  :outlined="!this.$store.state.STREAMER.HIHAT" color="#5ed0a6"  class="mx-auto">
                                        <v-icon v-if="this.$store.state.STREAMER.HIHAT" dark right>mdi-checkbox-marked-circle</v-icon>
                                        <span >Hihat Browser-source</span>

                                    </v-btn>


                                </v-card-actions>
                                <v-card-actions class="mt-4">
                                    <v-btn @click="test_donation" small :disabled="!this.$store.state.STREAMER.HIHAT" class="mx-auto">Skicka test-donation</v-btn>
                                </v-card-actions>
                                <v-card-subtitle style="position: absolute;bottom:0;">
                                    +Alerts direkt i ditt OBS
                                </v-card-subtitle>
                            </v-card>
                        </v-col>
                        <v-col class="col-12 col-lg-4 my-8">

                            <v-card
                                    dark
                                    width="400px"
                                    height="400px"
                                    class="mx-auto"

                            >
                                <v-avatar  style="position: absolute;top:10px;right:10px;" class="mr-0" height="40" width="40">
                                    <img
                                            :src="require('../assets/streamlabs_icon.png')"
                                    >
                                </v-avatar>


                                <v-card-text>
                                    <div style="width:100%;">

                                        Streamlabs

                                    </div>


                                </v-card-text>
                                <v-card-actions style="margin-top:100px;">
                                    <v-btn  href="/api/api_access" :outlined="!this.$store.state.STREAMER.STREAMLABS" @click="new_streamlabs" color="teal" class="mx-auto">
                                        <v-icon v-if="this.$store.state.STREAMER.STREAMLABS" dark right>mdi-checkbox-marked-circle</v-icon>
                                        <span v-if="this.$store.state.STREAMER.STREAMLABS">Skapa ny anslutning</span>
                                        <span v-if="!this.$store.state.STREAMER.STREAMLABS">Anslut till Streamlabs</span>

                                    </v-btn>


                                </v-card-actions>
                                <v-card-actions class="mt-4">
                                    <v-btn @click="test_donation" small :disabled="!this.$store.state.STREAMER.STREAMLABS" class="mx-auto">Skicka test-donation</v-btn>
                                </v-card-actions>
                                <v-card-subtitle style="position: absolute;bottom:0;">
                                    +Alerts genom Streamlabs
                                </v-card-subtitle>
                            </v-card>
                        </v-col>

                        <v-col class="col-12 col-lg-4 my-8">

                            <v-card
                                    dark
                                    width="400px"
                                    height="400px"
                                    class="mx-auto"
                            >
                              <v-avatar  style="position: absolute;top:10px;right:10px;" class="mr-0" height="40" width="40">
                                    <img
                                            :src="require('../assets/streamelements_icon.png')"
                                    >
                                </v-avatar>


                                <v-card-text>
                                    <div style="width:100%;">

                                        Streamelements

                                    </div>


                                </v-card-text>
                                <v-card-actions style="margin-top:100px;">
                                    <v-btn  :outlined="!this.$store.state.STREAMER.STREAMELEMENTS" @click="new_streamelements" color="orange" class="mx-auto">
                                        <v-icon v-if="this.$store.state.STREAMER.STREAMELEMENTS" dark right>mdi-checkbox-marked-circle</v-icon>
                                        <span v-if="this.$store.state.STREAMER.STREAMELEMENTS">Skapa ny anslutning</span>
                                        <span v-if="!this.$store.state.STREAMER.STREAMELEMENTS">Anslut till Streamelements</span>

                                    </v-btn>


                                </v-card-actions>
                                <v-card-actions class="mt-4">
                                    <v-btn small @click="test_donation" :disabled="!this.$store.state.STREAMER.STREAMELEMENTS" class="mx-auto">Skicka test-donation</v-btn>
                                    <v-btn small @click="test_se_bot" :disabled="!this.$store.state.STREAMER.STREAMELEMENTS" class="mx-auto">Skicka test-meddelande</v-btn>

                                </v-card-actions>
                                <v-card-subtitle style="position: absolute;bottom:0;">
                                    +Alerts och chatt-meddelanden genom Streamelements
                                </v-card-subtitle>
                            </v-card>
                        </v-col>
                        <v-col class="col-12 col-lg-4 my-8">
                            <v-card
                                    dark
                                    width="400px"
                                    height="400px"
                                    class="mx-auto"

                            >
                              <v-avatar  style="position: absolute;top:10px;right:10px;" class="mr-0" height="40" width="40">
                                    <img
                                            :src="require('../assets/nightbot_logo.png')"
                                    >
                                </v-avatar>


                                <v-card-text>
                                    <div style="width:100%;">

                                        Nightbot

                                    </div>


                                </v-card-text>
                                <v-card-actions style="margin-top:100px;">
                                    <v-btn  href="/api/nightbot_access" :outlined="!this.$store.state.STREAMER.HAS_NIGHTBOT"  color="purple" class="mx-auto">
                                        <v-icon v-if="this.$store.state.STREAMER.HAS_NIGHTBOT" dark right>mdi-checkbox-marked-circle</v-icon>
                                        <span v-if="this.$store.state.STREAMER.HAS_NIGHTBOT">Skapa ny anslutning</span>
                                        <span v-if="!this.$store.state.STREAMER.HAS_NIGHTBOT">Anslut till Nightbot</span>

                                    </v-btn>


                                </v-card-actions>
                                <v-card-actions class="mt-4">
                                    <v-btn small :disabled="!this.$store.state.STREAMER.HAS_NIGHTBOT" @click="test_nightbot" class="mx-auto">Skicka test-meddelande</v-btn>

                                </v-card-actions>
                                <v-card-subtitle style="position: absolute;bottom:0;">
                                    +Chatt-meddelanden genom Nightbot
                                </v-card-subtitle>
                            </v-card>
                        </v-col>
                      <v-col class="col-12 col-lg-4 my-8">
                        <v-card
                            dark
                            width="400px"
                            height="400px"
                            class="mx-auto"

                        >
                          <v-avatar  style="position: absolute;top:10px;right:10px;" class="mr-0" height="40" width="40">
                            <img
                                :src="require('../assets/discord_logo.png')"
                            >
                          </v-avatar>


                          <v-card-text>
                            <div style="width:100%;">

                              Discord-bot

                            </div>


                          </v-card-text>
                          <v-card-actions style="margin-top:100px;">
                            <v-btn target="_blank" href="https://discord.com/oauth2/authorize?client_id=984452286287839292&scope=bot&permission=2048" color="#7289DA" class="mx-auto">
                              <span>Lägg till bot</span>

                            </v-btn>


                          </v-card-actions>

                          <v-card-actions >
                            <v-btn small :disabled="$store.state.STREAMER.DISCORD_CHANNEL.length<6" @click="test_discord" class="mx-auto">Skicka test-meddelande</v-btn>

                          </v-card-actions>
                          <v-card-actions>
                            <v-text-field dense v-model="$store.state.STREAMER.DISCORD_CHANNEL" hint="Högerklicka på kanalen och kopiera id" class="mx-auto" style="max-width:250px;" dark outlined label="Kanal-ID">

                            </v-text-field>
                          </v-card-actions>
                          <v-card-subtitle style="position: absolute;bottom:0;">
                            +Alerts i given Discord-kanal
                          </v-card-subtitle>
                        </v-card>
                      </v-col>
                    </v-row>




        </v-container>

</template>

<script>

    export default {
        name: "Settings",
        data:function(){
            return{
                date: null,
                bank_name:"",
                save_streamer_timeout:null,
                donation_loading:false,
                hicards_loading:false,
                personal_loading:false,
                tab: null

            }
        },
        methods:{
            new_streamlabs:function(){
                this.$cookies.set("go_to",'alerts');
                window.location.href="/api/api_access"
            },
            new_streamelements:function(){
                this.$cookies.set("go_to",'alerts');
                window.location.href="/api/api_access_se"
            },

            new_hihat:function(){
                let http = new XMLHttpRequest();
                http.withCredentials = true;

                let url = '/api/use_hihat_overlay';
                http.open('POST', url, true);

                http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
                let self=this;
                http.onreadystatechange = function() {//Call a function when the state changes.


                    if(http.readyState === 4 && http.status === 400) {
                        self.$store.commit("update_snackbar","Ett fel inträffade.");

                    }
                    else if(http.readyState === 4 && http.status === 200){
                        self.$store.commit("use_hihat");



                    }

                };
                http.send();
            },
            save_all_settings:function(){
                this.$store.commit("save_streamer");

            },
            test_donation:function(){
                let http = new XMLHttpRequest();
                http.withCredentials = true;

                let url = '/api/api_test?';
                http.open('POST', url, true);

                http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
                let self=this;
                http.onreadystatechange = function() {//Call a function when the state changes.


                    if(http.readyState === 4 && http.status === 400) {
                        self.$store.commit("update_snackbar","Testdonationen kom inte fram.");

                    }
                    else if(http.readyState === 4 && http.status === 200){
                        self.$store.commit("update_snackbar","Testdonation skapad!");
                    }

                };
                http.send();
            },
            test_nightbot:function(){
                let http = new XMLHttpRequest();
                http.withCredentials = true;
                let url = '/api/nightbot_test?';
                http.open('POST', url, true);
                let self=this;
                http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');

                http.onreadystatechange = function() {//Call a function when the state changes.


                    if(http.readyState === 4 && http.status === 400) {

                        self.$store.commit("update_snackbar","Testmeddelandet kom inte fram.");


                    }
                    else if(http.readyState === 4 && http.status === 200){
                        self.$store.commit("update_snackbar","Testmeddelande skickat!");

                    }

                };
                http.send();
            },
          test_discord:function(){
            let http = new XMLHttpRequest();
            http.withCredentials = true;
            let url = '/api/discord_test?';
            http.open('POST', url, true);
            let self=this;
            http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');

            http.onreadystatechange = function() {//Call a function when the state changes.


              if(http.readyState === 4 && http.status === 400) {

                self.$store.commit("update_snackbar","Testmeddelandet kom inte fram.");


              }
              else if(http.readyState === 4 && http.status === 200){
                self.$store.commit("update_snackbar","Testmeddelande skickat!");

              }

            };
            http.send();
          },
            test_se_bot:function(){
                let http = new XMLHttpRequest();
                http.withCredentials = true;
                let url = '/api/se_bot_test?';
                http.open('GET', url, true);
                let self=this;
                http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');

                http.onreadystatechange = function() {//Call a function when the state changes.


                    if(http.readyState === 4 && http.status === 400) {
                        self.$store.commit("update_snackbar","Testmeddelandet kom inte fram.");


                    }
                    else if(http.readyState === 4 && http.status === 200){

                        self.$store.commit("update_snackbar","Testmeddelande skickat!");

                    }

                };
                http.send();
            }
        },
        computed:{


        },
        mounted:function(){
            document.title="Hihat - Alerts";

        }
    }
</script>

<style scoped>

</style>
